import { Controller } from "@hotwired/stimulus";

/**
 * アコーディオン式の開閉コンテンツを管理するStimulusコントローラー
 *
 * 使用場所:
 * - カート確認モーダル内で既に注文済みの商品がある場合の表示エリア
 *
 * 機能:
 * - 既注文商品一覧の表示/非表示の切り替え
 * - シェブロンアイコンの回転アニメーション（0度 ↔ 180度）
 * - 高さアニメーション付きの滑らかな開閉動作
 *
 * 必要な要素:
 * - data-toggle-target="content": 開閉対象のコンテンツ要素
 * - data-toggle-target="chevron": 方向を示すシェブロンアイコン要素
 */
export default class extends Controller {
  static targets = ["content", "chevron"];
  static values = { expanded: Boolean };

  toggle() {
    if (this.expandedValue) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    // コンテンツ部分の高さを取得して展開
    this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + "px";
    this.chevronTarget.style.transform = "rotate(180deg)";
    this.expandedValue = true;
  }

  collapse() {
    // コンテンツ部分を収納
    this.contentTarget.style.maxHeight = "0px";
    this.chevronTarget.style.transform = "rotate(0deg)";
    this.expandedValue = false;
  }
}
